import { useEffect } from 'react';

import { VStack, cn, useUnleash } from '@/package';
import { useAuthStore, useSideBarStore, useTenantStore } from '@/store';

import MenuItem from './MenuItem';
import TenantName from './TenantName';
import style from './style';

const SideBar = () => {
  const { user } = useAuthStore();
  const { currentTenantID: currentTenantId, getCurrentTenant } =
    useTenantStore();
  const tenantName = currentTenantId ? getCurrentTenant()!.tenantName : 'VueX';
  const {
    menuList,
    clean: cleanSideBarStore,
    disableMenu,
    enableMenu,
    setupMenuList,
  } = useSideBarStore();
  const { isEnabled } = useUnleash();

  const isAPIKey = isEnabled('vuex.miri.apiAnnotation');
  const isModelBuilderEnabled = isEnabled('vuex.demo.modelBuilder');
  const isModelingEnabled = isEnabled('vuex.sapporo.enabledModeling');

  useEffect(() => {
    if (isAPIKey) enableMenu('bottom', 'API Keys');
    else disableMenu('bottom', 'API Keys');

    if (isModelBuilderEnabled) enableMenu('top', 'Deployment');
    else disableMenu('top', 'Deployment');

    if (isModelingEnabled) enableMenu('top', 'Modeling');
    else disableMenu('top', 'Modeling');
  }, [
    isAPIKey,
    isModelBuilderEnabled,
    isModelingEnabled,
    JSON.stringify(menuList?.top.map(v => v.name)),
  ]);

  useEffect(() => {
    setupMenuList(user.role);
  }, [user.role]);

  useEffect(() => {
    return cleanSideBarStore;
  }, []);

  return (
    <div className={cn(style.SideBar)}>
      <div className={cn(style.UpperWrapper)}>
        <div
          role="button"
          onClick={() => {
            useTenantStore.getState().selectTenant();
            useTenantStore.getState().fetchTenantList();
          }}
        >
          <TenantName tenantName={tenantName} />
        </div>

        <VStack aria-label="sidebar-category" className="px-2" gap={0.25}>
          {menuList?.top.map(item => (
            <MenuItem key={item.name} {...item} />
          ))}
        </VStack>
      </div>

      <div>
        <VStack aria-label="sidebar-category" className="px-2" gap={0.25}>
          {menuList?.bottom.map(item => (
            <MenuItem key={item.name} {...item} />
          ))}
        </VStack>
      </div>
    </div>
  );
};

export default SideBar;
